import { __rest } from "tslib";
import React from 'react';
import { makeStyles, Typography as MuiTypography } from '@material-ui/core';
import clsx from 'clsx';
import { fonts, fontFamily } from '@getgo/chameleon-core';
const createFont = (name) => ({
    [name]: {
        font: fonts[name],
    },
});
const useStyles = makeStyles(() => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ root: {
        fontSize: 14,
        fontFamily,
    } }, createFont('body-small')), createFont('body-medium')), createFont('body-large')), createFont('caption-default-01')), createFont('caption-default-02')), createFont('caption-small-01')), createFont('caption-small-02')), createFont('heading-small')), createFont('heading-medium')), createFont('heading-large')), createFont('heading-xlarge')), createFont('button-text-small')), createFont('button-text-medium')), createFont('button-text-large')), createFont('button-text-xlarge'))));
export const Typography = (_a) => {
    var { className, children, variant = 'body-small' } = _a, otherProps = __rest(_a, ["className", "children", "variant"]);
    const classes = useStyles();
    return (React.createElement(MuiTypography, Object.assign({ className: clsx(classes.root, classes[variant], className) }, otherProps), children));
};
